import { appSyncApolloClient } from '../helpers/api';
import gql from 'graphql-tag';

export async function getGroups(orgId) {
  if (!orgId) return null;
  const resp = await appSyncApolloClient.query({
    fetchPolicy: 'no-cache',
    variables: {
      orgId: `org-${orgId}`,
      showSupportUsers: false,
    },
    query: gql`
      query getOrgInfo($orgId: String!, $showSupportUsers: Boolean) {
        getOrgInfo(orgId: $orgId, showSupportUsers: $showSupportUsers) {
          groups {
            name
            groupId
            permissions
          }
        }
      }
    `,
  });
  return resp.data.getOrgInfo.groups;
}

export async function getUserGroups(orgId, userId) {
  if (!orgId) return null;
  if (!userId) return null;
  const resp = await appSyncApolloClient.query({
    fetchPolicy: 'no-cache',
    variables: {
      orgId: `org-${orgId}`,
      userId: `user-${userId}`,
    },
    query: gql`
      query getOrgUser($orgId: String!, $userId: String!) {
        user: getOrgUser(orgId: $orgId, userId: $userId) {
          groups {
            groupId
            name
          }
        }
      }
    `,
  });
  return resp.data.user.groups;
}